import { isObject, defaults } from 'lodash';
/**
 * @param config { Object }
 * */

var mergeDefaultConfig = function mergeDefaultConfig(config) {
  return defaults(config, {
    defaultKey: undefined
  });
};
/**
 * @param customConfig { Object }
 * */

var createOverrideConfiguration = function createOverrideConfiguration(customConfig) {
  var config = customConfig;
  if (!isObject(customConfig)) {
    config = {};
  }
  config = mergeDefaultConfig(config);
  return config;
};
export default createOverrideConfiguration;